module.exports = __webpack_public_path__ + "static/img/3.ce837c1d.png";